import React from 'react';
import '../styles.css';

export default function Instructions(props) {
  const { step } = props;
  const opacity = [step === 1 || step === 3 ? 1 : 0.25, step === 2 || step === 3 ? 1 : 0.25];

  return (
    <div className="ms-instructions">
      <div className="ms-instructions-text" style={{ opacity: opacity[0] }}>
        In the set of five small objects below, find the one that matches one of the two big objects exactly (both in shape in color).
      </div>
      <div className="ms-instructions-text" style={{ opacity: opacity[1], marginTop: '10px' }}>
        If the exact match cannot be found, find the object that has nothing in common with either of the two (neither shape nor color).
      </div>
    </div>
  );
}
